import { render, staticRenderFns } from "./MenuItemBoxStatement.vue?vue&type=template&id=1b072708&"
import script from "./MenuItemBoxStatement.vue?vue&type=script&lang=js&"
export * from "./MenuItemBoxStatement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports